import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  Box,
} from "@chakra-ui/react";
import { ReactNode } from "react";

type IDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  cancelRef?: any;
};

const Dialog = ({ isOpen, onClose, cancelRef, children }: IDialogProps) => {
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent bg={"background"} mx="1rem">
          <Box
            borderRadius={"2rem"}
            border={"1px solid"}
            borderColor={"neutral.900"}
          >
            {children}
          </Box>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default Dialog;
